<template>
<div class="addNewTasks">
  <el-scrollbar style="height: calc(100vh - 144px)" ref="scrollbar">
    <div class="createdInner">
      <el-form :model="topForm"  ref="topForm" label-width="100px" class="demo-ruleForm" label-position="top" :status-icon="true" :show-message="false">
        <div class="topTask">
<!--          <div class="scedule">-->
<!--            <el-form-item label="Task Schedule" required>-->
<!--              <el-radio-group v-model="topForm.schedule_type">-->
<!--                <el-radio :label="1">-->
<!--                  Same-Hour-->
<!--                </el-radio>-->
<!--                <el-radio :label="2">-->
<!--                  2-Hour-->
<!--                </el-radio>-->
<!--                <el-radio :label="3">-->
<!--                  Same-Day-->
<!--                </el-radio>-->
<!--                <el-radio :label="4">-->
<!--                  Next Day-->
<!--                </el-radio>-->
<!--              </el-radio-group>-->
<!--            </el-form-item>-->
<!--          </div>-->
          <el-form-item label="Task type" required>
            <el-radio-group v-model="topForm.taskType">
              <el-radio :label="1">
                <div style="display: inline-block">
                  <div class="third">
                    <div class="hub">Hub</div>
                    <div>dropoff</div>
                  </div>
                </div>
              </el-radio>
              <el-radio :label="2">
                <div style="display: inline-block">
                  <div class="third"  style="background-color: #1472FF;padding-right: 0">
                    <div style="padding-left: 4px">Pickup</div>
                    <div class="change">Hub</div>
                  </div>
                </div>
              </el-radio>
              <el-radio :label="3">
                <div style="display: inline-block">
                  <div class="third">
                    <div class="pickup">Pickup</div>
                    <div>dropoff</div>
                  </div>
                </div>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
      </el-form>
      <el-form :model="thirdForm"  ref="thirdForm" label-width="100px" :rules="tasksRules2" class="demo-ruleForm" label-position="top" :status-icon="true" :show-message="false">
        <div v-if="topForm.taskType== 2 || topForm.taskType == 3">
          <h1  style="margin-bottom: 0;margin-top: 16px">Pickup Task</h1>
          <el-form-item label="Set Urgency" prop="region">
            <el-radio-group v-model="thirdForm.set_urgency">
              <el-radio :label="0">Normal</el-radio>
              <el-radio :label="1">High</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Customer Code" >
            <el-input v-model="thirdForm.code" placeholder="Customer Code" @blur="getNewAddress('pick')"></el-input>
          </el-form-item>
          <el-form-item label="Invoice#" prop="invoice#" required>
            <el-input v-model="thirdForm['invoice#']" placeholder="Invoice#" @blur="getDropCode"></el-input>
          </el-form-item>
          <el-form-item label="Contact Details" required>
            <!--              <el-input v-model="input" placeholder="Contact Details"></el-input>-->
            <contact-input ref="contact1"></contact-input>
          </el-form-item>
          <el-form-item label="Special instructions from customer">
            <el-input type="textarea" v-model="thirdForm.notes" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="Destination" required >
            <compose-input ref="compose1"></compose-input>
          </el-form-item>
          <el-form-item  prop="type">
          </el-form-item>
          <el-form-item label="Driver APP requirements" prop="resource">
            <el-checkbox-group v-model="thirdForm.checkList">
              <el-checkbox label="1">Customer signature</el-checkbox>
              <el-checkbox label="2">Photo of delivery</el-checkbox>
              <el-checkbox label="3">Add notes</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-form>
      <el-form :model="secoundForm"  ref="secoundForm" label-width="100px" :rules="tasksRules1" class="demo-ruleForm" label-position="top" :status-icon="true" :show-message="false">
        <div v-if="topForm.taskType== 1 || topForm.taskType == 3">
          <h1 style="margin-bottom: 0;margin-top: 16px">Dropoff Task</h1>
          <el-form-item label="Set Urgency" prop="region">
            <el-radio-group v-model="secoundForm.set_urgency">
              <el-radio :label="0">Normal</el-radio>
              <el-radio :label="1">High</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Customer Code" >
            <el-input
              v-model="secoundForm.code"
              placeholder="Customer Code"
              @blur="getNewAddress('dro')"></el-input>

          </el-form-item>
          <el-form-item label="Invoice#" prop="invoice#">
            <el-input v-model="secoundForm['invoice#']"
                      :disabled="topForm.taskType == 3?true:false"
                      placeholder="Invoice#"></el-input>
          </el-form-item>
          <el-form-item label="Contact Details" required>
            <!--              <el-input v-model="input" placeholder="Contact Details"></el-input>-->
            <contact-input ref="contact"></contact-input>
          </el-form-item>
          <el-form-item label="Special instructions from customer" prop="desc">
            <el-input type="textarea" v-model="secoundForm.notes" placeholder="" maxlength="100"></el-input>
            <div v-if="secoundForm.notes.length > 99" class="maxNotes">Maximum 100 words</div>
          </el-form-item>
          <el-form-item label="Destination" required >
            <compose-input ref="compose"></compose-input>
          </el-form-item>
          <el-form-item label="" prop="type">
          </el-form-item>
          <el-form-item label="Driver APP requirements" prop="resource">
            <el-checkbox-group v-model="secoundForm.checkList">
              <el-checkbox label="1">Customer signature</el-checkbox>
              <el-checkbox label="2">Photo of delivery</el-checkbox>
              <el-checkbox label="3">Add notes</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="taskLog">
      <el-popover
        v-model="showPop"
        popper-class="logPopper"
        placement="top-end"
        title="log"
        width="200"
        @hide="hidePop"
        @show="showPopLog"
        trigger="click">
        <div class="close">
          <img style="cursor: pointer" @click="showPop = false" src="../assets/image/minimum.png" alt="">
        </div>
        <div class="logList" v-for="(item,index) in logCreationList" :key="index">
          <div>{{item['invoice#']}}</div>
          <div class="time">
            <div>
              <span v-text="item.schedule_type == 1?'Same-Hour':item.schedule_type == 2?'2-Hour':item.schedule_type == 3?'Same-Day':'Next Day'"></span>
                | <span v-text="item.is_pickup == 1?'Pickup':'Dropoff'"></span>
            </div>
            <div>was created at {{item.createdTime}}</div>
          </div>
        </div>
        <span style="cursor: pointer"  slot="reference">
          Task Creation Log
        </span>
      </el-popover>
    </div>
    <div class="taskLogs">
      <el-popover
        v-model="showPop2"
        popper-class="logPopper"
        placement="top-end"
        title="log"
        width="200"
        trigger="click">
        <div class="close">
          <img style="cursor: pointer" @click="showPop2 = false;showPop = true" src="../assets/image/minimum.png" alt="">
        </div>
      </el-popover>
    </div>
  </el-scrollbar>
  <div class="footers">
    <div>
      <span style="margin-right: 18px">
      Automaticlly create after sacnning
      </span>
      <el-switch
        v-model="afterSacn"
        inactive-text="On"
        active-color="#82D237"
        inactive-color="#CCCCCC"
        @change="changeAuto"
      >
      </el-switch>
    </div>
    <div>
      <el-button type="primary" @click="cancelAdd" class="changes">Cancel</el-button>
      <el-button @click="confirmAdd" class="changeCreate">Create</el-button>
    </div>
  </div>
</div>
</template>

<script>
import composeInput from "@/components/composeInput";
import contactInput from "@/components/contactInput";
import {
  addNewTasksList,
  autoCreate,
  editTaskList,
  getAllProvice,
  getCodeAddress,
  getCopyMssage,
  scanTask
} from "@/api/tasks";
import store from "@/store";
import EventBus from "@/ws/eventBus";
import {addQuickTaskHandle} from "@/api/quickMatch";
import listenScan from "@/listenScanCode/listenScan";


export default {
  name: "addNewTasks",
  props:['title','id','quick_add'],
  components:{
    composeInput,contactInput,
    // VueGoogleAutocomplete
  },
  mounted() {
  },
  created() {
    this.afterSacn = localStorage.getItem('autoCreate') == 1?true:false
    if (localStorage.getItem('barCode')){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
      });
      let barCode = localStorage.getItem('barCode')
      scanTask({
        data: barCode
      }).then((res) => {
        loading.close()
        if (res.code === 200) {
          let checkList = []
          if (res.data.is_notes == 1){
            checkList.push('3')
          }
          if (res.data.is_photo == 1){
            checkList.push('2')
          }
          if (res.data.is_signature == 1){
            checkList.push('1')
          }
          this.topForm.taskType = 1
          for (let key of Object.keys(this.secoundForm)){
            this.secoundForm[key] = res.data[key]
          }
          for (let key of Object.keys(this.$refs.contact.form)){
            this.$refs.contact.form[key] = res.data[key]
          }
          getAllProvice().then(res=>{
            this.$refs.compose.changeForm['options'] = res.data.province
            // this.$refs.usernameComponent.changeForm.options =
          })

          for (let key of Object.keys(this.$refs.compose.changeForm)){
            this.$refs.compose.changeForm[key] = res.data[key]
          }
          this.secoundForm.checkList = checkList
          this.secoundForm.notes = ''
          //扫描完成一次后刷新页面
          //暂时取消
        } else {
        }
      }).catch((error) => {
        this.submitLoading = false;
        this.$message({
          message: error.data.msg,
          type: 'warning',
        });
      });
      localStorage.removeItem('barCode')
    }
    if (this.id){
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
      });
      getCopyMssage({id:this.id}).then(res=>{
        //type = 2
        loading.close()
        let checkList = []
        if (res.data.is_notes == 1){
          checkList.push('3')
        }
        if (res.data.is_photo == 1){
          checkList.push('2')
        }
        if (res.data.is_signature == 1){
          checkList.push('1')
        }
        this.topForm.schedule_type = res.data.schedule_type
        if(res.data.is_pickup == 1){
          this.topForm.taskType = 2
          for (let key of Object.keys(this.thirdForm)){
            this.thirdForm[key] = res.data[key]
          }
          for (let key of Object.keys(this.$refs.contact1.form)){
            this.$refs.contact1.form[key] = res.data[key]
          }
          for (let key of Object.keys(this.$refs.compose1.changeForm)){
            this.$refs.compose1.changeForm[key] = res.data[key]
          }
          // this.$refs.compose1.changeForm['options'] = [{label:'ON',value:'ON'},]

          getAllProvice().then(res=>{
            this.$refs.compose1.changeForm['options'] = res.data.province
            // this.$refs.usernameComponent.changeForm.options =
          })
          this.thirdForm.checkList = checkList
          this.thirdForm.notes = ''
          // type = 1
        }else if (res.data.is_pickup == 0){
          this.topForm.taskType = 1
          for (let key of Object.keys(this.secoundForm)){
            this.secoundForm[key] = res.data[key]
          }
          for (let key of Object.keys(this.$refs.contact.form)){
            this.$refs.contact.form[key] = res.data[key]
          }
          for (let key of Object.keys(this.$refs.compose.changeForm)){
            this.$refs.compose.changeForm[key] = res.data[key]
          }
          getAllProvice().then(res=>{
            this.$refs.compose.changeForm['options'] = res.data.province
          })
          this.secoundForm.checkList = checkList
          this.secoundForm.notes = ''
        }

      })
    }
  },
  data(){
    return{
      showPop2:true,
      showPop:false,
      newAddressElem:'',
      afterSacn:true,
      topForm:{
        schedule_type:1,
       taskType:1
      },
      secoundForm:{
        set_urgency:0,
        code:"",
        'invoice#':'',
        notes:'',
        checkList:['2']
      },
      thirdForm:{
        set_urgency:0,
        code:"",
        'invoice#':'',
        notes:'',
        checkList:['2']
      },
      tasksRules1:{
        code: [
          { required: true, message: '', trigger: 'blur' }
        ],
        'invoice#': [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      tasksRules2:{
        code: [
          { required: true, message: '', trigger: 'blur' }
        ],
       'invoice#': [
          { required: true, message: '', trigger: 'blur' }
        ],
      }
    }
  },
  computed:{
    logCreationList(){
      let arr = localStorage.getItem('logList')
      let arr1 = []
      if  (arr){
        arr = JSON.parse(arr)
        arr.forEach(v=>{
          if (v.dropoff){
            arr1.push(v.dropoff)
          }else if (v.pickup){
            arr1.push(v.pickup)
          }
        })
      }else {
        arr1 = arr
      }

      return arr1
    },
  },
  watch:{
  },
  methods:{
    hidePop(){
      this.showPop =false
      this.showPop2 = true
    },
    showPopLog(){
      this.showPop = true
      this.showPop2 = false
    } ,
    //外面的 form
    changeAuto(){
      autoCreate({
        autocreate:this.afterSacn == true?1:0
      }).then(res=>{
        if (res.code == 200){
          if (this.afterSacn){
            localStorage.setItem('autoCreate','1')
          }else {
            localStorage.setItem('autoCreate','0')
          }
        }
      })
    },
    validateForm() {
      let flag = false
      this.$refs['topForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },

    //第二个 form
    validateForm2() {
      let flag = false
      this.$refs['secoundForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateclear(){
      this.$nextTick(() => {
        if (this.$refs.secoundForm) {
          this.$refs.secoundForm.resetFields()
        }
      })
      this.secoundForm={
        set_urgency:0,
          code:"",
          'invoice#':'',
          notes:'',
          checkList:['2']
      }
    },
    //第三个form
    validateForm3() {
      let flag = false
      this.$refs['thirdForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    validateclear2(){
      this.$nextTick(() => {
        this.$refs.thirdForm.resetFields()
      })
      this.thirdForm={
        set_urgency:0,
          code:"",
          'invoice#':'',
          notes:'',
          checkList:['2']
      }
    },
    //关闭弹框时清除表单校验 以及数据
    cancelAdd(){
      this.$emit('closeDialog')
      let taskType = this.topForm.taskType //task 类型
      // window.location.reload()
      if(taskType == 1){
        this.$refs.compose.validateClear()
        this.$refs.contact.validateClear()
        this.validateclear()
      }else if (taskType == 2){
        this.$refs.compose1.validateClear()
        this.$refs.contact1.validateClear()
        this.validateclear2()
      }else {
        this.$refs.compose.validateClear()
        this.$refs.contact.validateClear()
        this.validateclear()
        this.$refs.compose1.validateClear()
        this.$refs.contact1.validateClear()
        this.validateclear2()
      }
      this.topForm.taskType = 1
    },
    //新增 编辑 或者copy
    confirmAdd(){
      //表单校验
      let taskType = this.topForm.taskType //task 类型
      let schedule_type = this.topForm.schedule_type
      let pss = false
      if (taskType == 1){
        let form = this.validateForm()
        let secounds =this.validateForm2()
        let third =this.$refs.contact.validateForm()
        let fouth =this.$refs.compose.validateForm()
        if (!form || !secounds ||!third ||!fouth){
          this.$message({
            message: 'Some information missing',
            type: 'warning'
          });
          pss = true
        }
      }else if (taskType == 2){
        let form = this.validateForm()
        let secounds =this.validateForm3()
        let third =this.$refs.contact1.validateForm()
        let fouth =this.$refs.compose1.validateForm()
        if (!form || !secounds ||!third ||!fouth){
          this.$message({
            message: 'Some information missing',
            type: 'warning'
          });
          pss = true
        }
      }else if (taskType == 3){
        let form = this.validateForm()
        let secounds =this.validateForm2()
        let third =this.$refs.contact.validateForm()
        let fouth =this.$refs.compose.validateForm()
        let secounds1 =this.validateForm3()
        let third1 =this.$refs.contact1.validateForm()
        let fouth1 =this.$refs.compose1.validateForm()
        if (!form || !secounds ||!third ||!fouth ||!fouth1 ||!third1 ||!secounds1){
          this.$message({
            message: 'Some information missing',
            type: 'warning'
          });
          pss = true
        }
      }
        //判断 task type
        //判断类型 调接口 新增或者 copy
      if (!pss){
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
        });
        let form = {}
        if (taskType == 1){
          //dropoff
          let contact = this.$refs.contact.form
          let compose = this.$refs.compose.changeForm
          let secound = this.secoundForm
          form.dropoff = Object.assign(contact,compose)
          form.dropoff = Object.assign(form.dropoff,secound)
          form.dropoff.is_signature = form.dropoff.checkList.includes('1')?1:0
          form.dropoff.is_photo = form.dropoff.checkList.includes("2")?1:0
          form.dropoff.is_notes = form.dropoff.checkList.includes('3')?1:0
          form.dropoff.is_pickup = 0
          // form.dropoff.auto_assign = this.afterSacn == true?1:0
          form.dropoff.auto_assign = '0'
          // form.dropoff.address = document.getElementById('autocomplete').value
          form.dropoff.sub_organization_id = this.$store.state.store
          form.dropoff.schedule_type = schedule_type
          // delete form.dropoff.code
          delete form.dropoff.id
          delete form.dropoff.options
          delete form.dropoff.checkList
        }else if (taskType == 2){
          //pickup
          let contact1 = this.$refs.contact1.form
          let compose1 = this.$refs.compose1.changeForm
          let third = this.thirdForm
          form.pickup = Object.assign(contact1,compose1)
          form.pickup = Object.assign(form.pickup,third)
          form.pickup.is_signature = form.pickup.checkList.includes('1')?1:0
          form.pickup.is_photo = form.pickup.checkList.includes('2')?1:0
          form.pickup.is_notes = form.pickup.checkList.includes('3')?1:0
          form.pickup.is_pickup = 1
          // form.pickup.auto_assign = this.afterSacn == true?1:0
          form.pickup.auto_assign = '0'
          // form.pickup.address = document.getElementById('autocomplete').value
          form.pickup.sub_organization_id = this.$store.state.store
          form.pickup.schedule_type = schedule_type
          // delete form.pickup.code
          delete form.pickup.id
          delete form.pickup.options
          delete form.pickup.checkList
        }else if (taskType == 3){
          let contact1 = this.$refs.contact1.form
          let compose1 = this.$refs.compose1.changeForm
          let third = this.thirdForm
          form.pickup = Object.assign(contact1,compose1)
          form.pickup = Object.assign(form.pickup,third)
          form.pickup.is_signature = form.pickup.checkList.includes('1')?1:0
          form.pickup.is_photo = form.pickup.checkList.includes('2')?1:0
          form.pickup.is_notes = form.pickup.checkList.includes('3')?1:0
          form.pickup.sub_organization_id = this.$store.state.store
          form.pickup.auto_assign = '0'
          form.pickup.schedule_type = schedule_type
          form.pickup.is_pickup = 1
          // delete form.pickup.code
          delete form.pickup.id
          delete form.pickup.options
          delete form.pickup.checkList

          let contact = this.$refs.contact.form
          let compose = this.$refs.compose.changeForm
          let secound = this.secoundForm
          form.dropoff = Object.assign(contact,compose)
          form.dropoff = Object.assign(form.dropoff,secound)
          form.dropoff.is_signature = form.dropoff.checkList.includes('1')?1:0
          form.dropoff.is_photo = form.dropoff.checkList.includes('2')?1:0
          form.dropoff.is_notes = form.dropoff.checkList.includes('3')?1:0
          form.dropoff.sub_organization_id = this.$store.state.store
          form.dropoff.auto_assign = '0'
          form.dropoff.schedule_type = schedule_type
          form.dropoff.is_pickup = 0
          // delete form.dropoff.code
          delete form.dropoff.id
          delete form.dropoff.options
          delete form.dropoff.checkList
        }
        if (this.title == 'Create a New Task' ||this.title == 'Copy Task'){
          // console.log(JSON.stringify(form),'dddd')
          if (this.quick_add){
            addQuickTaskHandle(form).then(res=>{
              loading.close()
              if (res.code == 200){
                // EventBus.$emit('newTaskCome')
                EventBus.$emit('updateQuickTaskList',res.data)
                this.$message({
                  message: res.msg,
                  type: 'success'
                });
                this.$emit('closeDialog')
                // window.location.reload()
                //新增时，将新增信息添加到 session 回显log
                //获取当前时间
                this.getCurrentTimes()
                if  (form.pickup){
                  form.pickup.createdTime = this.getCurrentTimes()
                }else if(form.dropoff){
                  form.dropoff.createdTime = this.getCurrentTimes()
                }
                if (localStorage.getItem('logList')){
                  //如果存在 就取出来 重新赋值
                  let arr =localStorage.getItem('logList')
                  arr = JSON.parse(arr)
                  arr.push(form)
                  localStorage.removeItem('logList');
                  localStorage.setItem("logList", JSON.stringify(arr));
                }else {
                  let arr2 = [form]
                  localStorage.setItem("logList", JSON.stringify(arr2));
                }
                //清除表单校验 表单数据
              }else {
                this.$message({
                  message: res.msg,
                  type: 'warning'
                });
              }
            }).catch(err=>{
              this.$message({
                message: err.msg,
                type: 'warning'
              });
            })
          }else {
            addNewTasksList(form).then(res=>{
              loading.close()
              if (res.code == 200){
                // EventBus.$emit('newTaskCome')
                EventBus.$emit('updateTaskList')
                this.$message({
                  message: res.msg,
                  type: 'success'
                });
                this.$emit('closeDialog')
                // window.location.reload()
                //新增时，将新增信息添加到 session 回显log
                //获取当前时间
                this.getCurrentTimes()
                if  (form.pickup){
                  form.pickup.createdTime = this.getCurrentTimes()
                }else if(form.dropoff){
                  form.dropoff.createdTime = this.getCurrentTimes()
                }
                if (localStorage.getItem('logList')){
                  //如果存在 就取出来 重新赋值
                  let arr =localStorage.getItem('logList')
                  arr = JSON.parse(arr)
                  arr.push(form)
                  localStorage.removeItem('logList');
                  localStorage.setItem("logList", JSON.stringify(arr));
                }else {
                  let arr2 = [form]
                  localStorage.setItem("logList", JSON.stringify(arr2));
                }
                //清除表单校验 表单数据
              }else {
                this.$message({
                  message: res.msg,
                  type: 'warning'
                });
              }
            }).catch(err=>{
              this.$message({
                message: err.msg,
                type: 'warning'
              });
            })
          }

        }else if (this.title == 'Edit Task'){
          let form1 = {}
          if (taskType == 1){
            form1 = form.dropoff
            form1.address = this.$refs.compose.changeForm.address
          }else if (taskType == 2){
            form1 = form.pickup
            form1.address = this.$refs.compose1.changeForm.address
          }
          form1.id = this.id
          editTaskList(form1).then(res=>{
            loading.close()
            if (res.code == 200){
              this.$message({
                message: res.msg,
                type: 'success'
              });
              this.$emit('closeDialog')
            }else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });

            }
          }).catch(err=>{
            this.$message({
              message: err.msg,
              type: 'warning'
            });
          })
        }
      }
      // console.log(listenScan.barCode,'ddd')
      listenScan.barCode = ''
      // console.log(listenScan,'sss')
    },
    getCurrentTimes(){
      let date = new Date()
      let formattedDate = date.toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true })
      return formattedDate
    },
    //getNewAddress 失焦 获取address 后回填
    getDropCode(){
      if (this.topForm.taskType == 3){
        this.secoundForm['invoice#'] = this.thirdForm['invoice#'] + 'D'
      }
    },
    getNewAddress(type){
      let code = ''
      if (this.thirdForm.code!= '' || this.secoundForm.code !=''){
        if (type == 'dro'){
          code = this.secoundForm.code
        }else if(type == 'pick'){
          code = this.thirdForm.code
        }
        let options = []
        getAllProvice().then(res=>{
         options = res.data.province
          // this.$refs.usernameComponent.changeForm.options =
        })
        getCodeAddress({
          code:code,
          sub_organization_id : this.$store.state.store
        }).then(res=>{
          if (res.code == 200){
            if (type == 'dro'){
              this.$refs.compose.changeForm = res.data
              this.$refs.contact.form = res.data
              this.$refs.contact.form.phone_code = 1
              this.$refs.compose.changeForm.options = options
            }else if(type == 'pick' ) {
              this.$refs.compose1.changeForm = res.data
              this.$refs.contact1.form = res.data
              this.$refs.contact1.form.phone_code = 1
              this.$refs.compose1.changeForm.options = options
            }else {
              this.$refs.compose.changeForm = res.data
              this.$refs.contact.form = res.data
              this.$refs.contact.form.phone_code = 1
              this.$refs.compose.changeForm.options = options
              this.$refs.compose1.changeForm = res.data
              this.$refs.contact1.form = res.data
              this.$refs.contact1.form.phone_code = 1
              this.$refs.compose1.changeForm.options = options
            }
          }else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
        })
      }

    }
  }
}
</script>




<style scoped lang="less">
.addNewTasks{
  margin-left: 8px;
  /deep/.el-scrollbar__wrap{
    overflow: auto;
  }
  .createdInner{
    width: 38%;
    //overflow: auto;
    text-align: left;
    font-size: 14px;
    font-family: SFPro-Regular, SFPro;
    font-weight: 400;
    color:#1F2D42;
    padding-bottom: 50px;

    .topTask{
      padding-bottom: 16px;
      border-bottom: 1px solid #E0E0E0;
      /deep/ .el-radio{
        font-weight: bold;
      }
      .scedule{
        /deep/.el-radio{
          font-weight: normal;
        }
      }
    }
    .maxNotes{
      margin-top: 8px;
      text-align: right;
      color: #E95646;
    }
    .time{
      width: 100%;
      //position: relative;
      /deep/.el-input__prefix{
        position: absolute;
        top: 0;
        right: 12px;
        left: auto;
      }
     /deep/ .el-input--prefix .el-input__inner{
        padding-left: 12px;
      }
      /deep/.el-input__icon{
        //position: absolute;
        //right: 12px;
        color: #D65953;
      }
    }
    .third{
      display: flex;
      padding-right: 5px;
      color: #FFFFFF;
      height: 18px;
      line-height: 18px;
      margin-top: 8px;
      background-color: #FFC215;
      font-size: 12px;
      border-radius: 4px;
      .hub{
        background-color: #1F2D42;
        border-radius: 4px;
        padding: 0 5px;
        margin-right: 5px;
      }
      .change{
        background-color: #1F2D42;
        border-radius: 4px;
        padding: 0 5px;
        margin-left: 5px;
      }
      .pickup{
        background:#1472FF;
        padding: 0 5px;
        margin-right: 5px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
  }
  .taskLog{
    width:calc(100% - 28px);
    text-align: right;
    position: relative;
  }
  .taskLogs{
    width:calc(100% - 28px);
    text-align: right;
    position: absolute;
    right: 25px;
    bottom: 110px;
  }
  .footers{
    width:calc( 100% - 72px);
    z-index: 1;
    height: 64px;
    background: #1F2D42;
    position: fixed;
    bottom: 0;
    margin-left: -32px;
    line-height: 64px;
    display: flex;
    justify-content: space-between;
    padding-right: 48px;
    padding-left: 32px;
    color: #FFFFFF;
    .changeCreate{
      color: #1F2D42;
    }
    .changeCreate:focus{
      border-color: #FFFFFF;
      background-color: #FFFFFF;
    }
    .changeCreate:hover{
      border-radius: 16px;
      border: 1px solid #FFFFFF;
      background: #1F2D42;
      color: #FFFFFF;
    }
  }
}
</style>
<style lang="less">
.logList{
  display: flex;
  font-size: 14px;
  font-weight: bold;
  color: #1F2D42;
  line-height: 20px;
  margin-top: 10px;
  .time{
    font-weight: normal;
    margin-left:10px ;
  }
}
</style>
